import React from 'react';
import styled from 'styled-components';
import heroImageOne from '../../assets/heroImgaeOne.png';
import heroImageTwo from '../../assets/heroImgaeTwo.png';

export default function Secondcomp() {
 return (
  <Container>
   <Wrapper>
    <Hero />
    <InfoSection />
   </Wrapper>
  </Container>
 );
}

function Hero() {
 return (
  <HeroContainer>
   <HeroImageContainer>
    <HeroImage
     src={heroImageOne}
     alt='figure depicting sustainable development'
    ></HeroImage>
   </HeroImageContainer>
   <HeroDescription>
    <HeroContent>
     <h3>Is this applicable for my company?</h3>
     <p>
      If you produce, import, or manufacture plastic for packaging your
      products, then you should abide by the Plastic Waste Management (PWM)
      Rules, 2016
     </p>{' '}
     <p>
      If you produce, consume, manufacture, or import electronic products, then
      you should abide by the E-Waste (Management) rules, 2016.
     </p>
    </HeroContent>
   </HeroDescription>
  </HeroContainer>
 );
}

function InfoSection() {
 return (
  <InfoContainer>
   <div>
    <div className='header'>
     <Heading>Plastic Waste</Heading>
     <Linebreak>
      <div className='part1'></div>
      <div className='part2'></div>
      <div className='part3'></div>
     </Linebreak>
    </div>
    <Content>
     <p>
      The Plastic Waste Management (PWM) Rules shall apply to every producer,
      importer or brand owner who introduce products with plastic packaging into
      the market, then you need to establish a system for collecting back the
      plastic waste generated due to your products. Plastic packaging includes
      all types of plastics i.
     </p>{' '}
     <h3>How can my Company Collect back the Plastic Waste?</h3>
     <p>There are three ways for you to collect back the plastic waste</p>{' '}
     <ul>
      <li>
       <p>Through your own distribution channel</p>
      </li>
      <li>
       <p>Tie-up with Urban Local Bodies (ULBs)</p>
      </li>
      <li>
       <p>Work with PROs and waste management companies</p>
      </li>
     </ul>
    </Content>
   </div>
   <div>
    <Image src={heroImageTwo} alt='hand holding a small plant' />
   </div>
  </InfoContainer>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #fff;
`;

const Wrapper = styled.div`
 width: 75%;
 margin: 0 auto 8rem auto;
 padding-top: 2rem;
 @media screen and (max-width: 600px) {
  width: 90%;
 }
`;
// Hero Components
const HeroContainer = styled.div`
 width: 100%;
 background: #ffffff;
 position: relative;
 box-shadow: 0px 0px 17px rgba(0, 0, 0, 0.25);
 display: flex;
 /* font-family: 'Segoe UI'; */
 margin-top: -4rem;
 z-index: 100;
 @media screen and (max-width: 600px) {
  flex-direction: column-reverse;
 }
`;

const HeroImageContainer = styled.div`
 width: 30%;
 padding: 2rem;
 text-align: center;
 @media screen and (max-width: 600px) {
  width: 70%;
  margin: 0 auto;
 }
`;

const HeroImage = styled.img`
 width: 80%;
 height: auto;
 object-fit: cover;
`;

const HeroDescription = styled.div`
 width: 60%;
 height: 100%;
 @media screen and (max-width: 600px) {
  width: 90%;
  margin: 0 auto;
 }
`;

const HeroContent = styled.div`
 position: absolute;
 width: 70%;
 top: 0;
 height: 120%;
 flex-direction: column;
 gap: 2rem;
 background-color: #90d62b;
 box-shadow: 0px 0px 29px rgba(0, 0, 0, 0.25);
 border-radius: 2.5rem;
 padding: 4rem 5rem;
 transform: translate(-3%, -10%);
 text-align: justify;
 @media screen and (max-width: 600px) {
  position: static;
  width: 100%;
  margin: 0 auto;
  transform: translate(0%, -10%);
 }
 h3 {
  /* font-family: 'Segoe UI'; */
  font-weight: 600;
  font-size: 2rem;
  line-height: 2rem;
  color: #fff;
  margin-bottom: 3rem;
  text-transform: capitalize;
 }
 p {
  /* font-family: 'Segoe UI'; */
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2rem;
  color: #fff;
  margin-bottom: 2rem;
 }
`;

//Info Section
const InfoContainer = styled.div`
 display: flex;
 align-items: center;
 width: 100%;
 margin-top: 5rem;
 > div:first-child {
  width: 65%;
 }
 > div:nth-child(2) {
  width: 35%;
 }
 div {
  height: 100%;
 }
 .header {
  width: fit-content;
 }
 @media screen and (max-width: 600px) {
  flex-direction: column;
 }
`;

const Heading = styled.h1`
 font-size: 3.2rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #404040;
`;

const Linebreak = styled.div`
 width: 50%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Content = styled.div`
 margin-top: 2rem;
 /* font-family: 'Segoe UI'; */
 color: #707070;
 text-align: justify;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 h3 {
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 2, 8rem;
  text-transform: capitalize;
 }
 p {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
 }
`;

const Image = styled.img`
 width: 100%;
 height: auto;
 object-fit: cover;
`;
